

import React, { useState, useEffect } from 'react';
import styles from "./BusinessLandingPagePureCSS.module.css"
import LandingNavBarBusiness from "../components/Navbar/LandingPageNavBarBusiness"

// Dummy components to avoid breaking the page.
// In a real scenario, these would be properly implemented or imported.
const Button = ({ children, ...props }) => <button {...props}>{children}</button>
const Card = ({ children, ...props }) => <div {...props}>{children}</div>
const Badge = ({ children, ...props }) => <div {...props}>{children}</div>
const Avatar = ({ children, ...props }) => <div {...props}>{children}</div>
const AvatarImage = (props) => <img {...props} />
const AvatarFallback = ({ children, ...props }) => <div {...props}>{children}</div>

// Placeholder icons
const TrendingUp = () => <span>Trending Up</span>
const DollarSign = () => <span>$</span>
const Star = () => <span>*</span>
const CheckCircle = () => <span>✓</span>
const ArrowRight = () => <span>→</span>
const Play = () => <span>▶</span>
const Zap = () => <span>⚡</span>
const Target = () => <span>🎯</span>
const Clock = () => <span>🕒</span>
const Award = () => <span>🏆</span>
const BarChart3 = () => <span>📊</span>
const MessageSquare = () => <span>💬</span>
const Calendar = () => <span>📅</span>
const MapPin = () => <span>📍</span>
const Eye = () => <span>👁️</span>
const Heart = () => <span>❤️</span>
const ChevronLeft = () => <span>‹</span>
const ChevronRight = () => <span>›</span>
const HardHat = () => <span>👷</span>
const Phone = () => <span>📞</span>

const BusinessLandingPagePureCSS = () => {
  const [currentJobSlide, setCurrentJobSlide] = useState(0)
  const [isVisible, setIsVisible] = useState({})

  const liveJobs = [
    {
      id: 1,
      title: "Complete Kitchen Renovation",
      location: "Sydney CBD",
      budget: "$25,000 - $35,000",
      postedTime: "2 hours ago",
      description:
        "Looking for experienced contractor to renovate entire kitchen including cabinets, countertops, and appliances.",
      urgency: "High",
      responses: 12,
      category: "Renovation",
    },
    {
      id: 2,
      title: "Emergency Plumbing Repair",
      location: "Melbourne",
      budget: "$500 - $1,000",
      postedTime: "30 minutes ago",
      description: "Urgent plumbing issue - burst pipe in bathroom needs immediate attention.",
      urgency: "Urgent",
      responses: 8,
      category: "Plumbing",
    },
    {
      id: 3,
      title: "House Painting - Interior & Exterior",
      location: "Brisbane",
      budget: "$8,000 - $12,000",
      postedTime: "1 hour ago",
      description: "3-bedroom house needs complete interior and exterior painting. Quality work required.",
      urgency: "Medium",
      responses: 15,
      category: "Painting",
    },
    {
      id: 4,
      title: "Bathroom Renovation",
      location: "Perth",
      budget: "$15,000 - $20,000",
      postedTime: "4 hours ago",
      description: "Master bathroom renovation including tiling, fixtures, and waterproofing.",
      urgency: "Medium",
      responses: 9,
      category: "Renovation",
    },
    {
      id: 5,
      title: "Electrical Installation",
      location: "Adelaide",
      budget: "$2,000 - $3,500",
      postedTime: "3 hours ago",
      description: "New electrical installation for home office and outdoor lighting.",
      urgency: "Low",
      responses: 6,
      category: "Electrical",
    },
  ]

  const successStories = [
    {
      name: "Mike's Plumbing Services",
      monthlyJobs: 47,
      monthlyRevenue: "$28,500",
      growth: "+156%",
      testimonial:
        "BuildStart transformed my business. I went from 12 jobs per month to 47 jobs. The quality of leads is exceptional!",
      image: "/placeholder.svg?height=80&width=80",
      joinedDate: "6 months ago",
    },
    {
      name: "Elite Home Renovations",
      monthlyJobs: 23,
      monthlyRevenue: "$145,000",
      growth: "+89%",
      testimonial:
        "The premium subscription pays for itself within days. High-value projects and serious customers only.",
      image: "/placeholder.svg?height=80&width=80",
      joinedDate: "1 year ago",
    },
    {
      name: "Quick Fix Electrical",
      monthlyJobs: 62,
      monthlyRevenue: "$31,200",
      growth: "+203%",
      testimonial: "I'm booked solid thanks to BuildStart. The instant notifications mean I never miss an opportunity.",
      image: "/placeholder.svg?height=80&width=80",
      joinedDate: "8 months ago",
    },
  ]

  const pricingPlans = [
    {
      name: "Starter",
      price: "$49",
      period: "/month",
      description: "Perfect for new businesses",
      features: [
        "Up to 10 job leads per month",
        "Basic profile listing",
        "Customer messaging",
        "Mobile app access",
        "Email support",
      ],
      popular: false,
    },
    {
      name: "Professional",
      price: "$99",
      period: "/month",
      description: "Most popular for growing businesses",
      features: [
        "Unlimited job leads",
        "Premium profile with photos",
        "Priority in search results",
        "Advanced analytics",
        "Phone & email support",
        "Lead management tools",
      ],
      popular: true,
    },
    {
      name: "Enterprise",
      price: "$199",
      period: "/month",
      description: "For established businesses",
      features: [
        "Everything in Professional",
        "Dedicated account manager",
        "Custom branding options",
        "API access",
        "Priority customer support",
        "Advanced reporting",
      ],
      popular: false,
    },
  ]

  const stats = [
    { number: "2.3M+", label: "Jobs Posted Monthly", icon: Target },
    { number: "$847M", label: "Total Project Value", icon: DollarSign },
    { number: "94%", label: "Customer Satisfaction", icon: Star },
    { number: "< 2hrs", label: "Average Response Time", icon: Clock },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentJobSlide((prev) => (prev + 1) % Math.ceil(liveJobs.length / 3))
    }, 5000)

    return () => clearInterval(interval)
  }, [liveJobs.length])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }))
          }
        })
      },
      { threshold: 0.1 },
    )

    document.querySelectorAll("[data-animate]").forEach((el) => {
      observer.observe(el)
    })

    return () => observer.disconnect()
  }, [])

  const nextJobSlide = () => {
    setCurrentJobSlide((prev) => (prev + 1) % Math.ceil(liveJobs.length / 3))
  }

  const prevJobSlide = () => {
    setCurrentJobSlide((prev) => (prev - 1 + Math.ceil(liveJobs.length / 3)) % Math.ceil(liveJobs.length / 3))
  }

  return (
    <div className={styles.businessLandingPage}>
      <LandingNavBarBusiness />

      {/* Hero Section */}
      <section className={styles.businessHeroSection}>
        <div className={styles.businessHeroBackground}>
          <div className={styles.businessHeroGradient}></div>
          <div className={styles.businessHeroPattern}></div>
        </div>

        <div className={styles.businessHeroContent}>
          <div className={styles.businessHeroText}>
            <h1 className={styles.businessHeroTitle}>
              Grow Your Business with
              <br />
              <span className={styles.businessHeroHighlight}>High-Quality Job Leads</span>
            </h1>
            <p className={styles.businessHeroSubtitle}>
              Join the thousands of professionals earning more with BuildStart. Get instant access to premium job opportunities
              in your area and grow your revenue.
            </p>
          </div>

          <div className={styles.businessHeroStats}>
            {stats.map((stat, index) => (
              <div key={index} className={styles.businessHeroStat}>
                <stat.icon className={styles.businessHeroStatIcon} />
                <div className={styles.businessHeroStatContent}>
                  <div className={styles.businessHeroStatNumber}>{stat.number}</div>
                  <div className={styles.businessHeroStatLabel}>{stat.label}</div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.businessHeroActions}>
            <Button size="lg" className={styles.businessCtaPrimary}>
              <Zap />
              Start Free Trial
            </Button>
            <Button size="lg" variant="outline" className={`${styles.businessCtaSecondary} bg-transparent`}>
              <Play />
              Watch Success Stories
            </Button>
          </div>
        </div>
      </section>

      {/* Live Jobs Carousel */}
      <section className={styles.liveJobsSection} id="live-jobs" data-animate>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Live Job Opportunities</h2>
            <p className={styles.sectionSubtitle}>Real jobs posted by homeowners in the last 24 hours - don't miss out!</p>
          </div>

          <div className={styles.jobsCarouselContainer}>
            <button onClick={prevJobSlide} className={`${styles.carouselNavBtn} ${styles.carouselPrev}`}>
              <ChevronLeft />
            </button>

            <div className={styles.jobsCarousel}>
              <div className={styles.jobsCarouselTrack} style={{ transform: `translateX(-${currentJobSlide * 100}%)` }}>
                {Array.from({ length: Math.ceil(liveJobs.length / 3) }).map((_, slideIndex) => (
                  <div key={slideIndex} className={styles.jobsCarouselSlide}>
                    {liveJobs.slice(slideIndex * 3, (slideIndex + 1) * 3).map((job) => (
                      <Card key={job.id} className={styles.liveJobCard}>
                        <div className={styles.jobHeader}>
                          <div className={styles.jobUrgency}>
                            <Badge
                              className={`${styles.urgencyBadge} ${
                                job.urgency === "Urgent"
                                  ? styles.urgencyUrgent
                                  : job.urgency === "High"
                                    ? styles.urgencyHigh
                                    : styles.urgencyMedium
                              }`}
                            >
                              {job.urgency}
                            </Badge>
                            <span className={styles.jobPostedTime}>{job.postedTime}</span>
                          </div>
                          <div className={styles.jobResponses}>
                            <Eye />
                            <span>{job.responses} responses</span>
                          </div>
                        </div>

                        <h3 className={styles.jobTitle}>{job.title}</h3>

                        <div className={styles.jobMeta}>
                          <div className={styles.jobLocation}>
                            <MapPin />
                            <span>{job.location}</span>
                          </div>
                          <div className={styles.jobBudget}>
                            <DollarSign />
                            <span>{job.budget}</span>
                          </div>
                        </div>

                        <p className={styles.jobDescription}>{job.description}</p>

                        <div className={styles.jobActions}>
                          <Button className={styles.jobQuoteBtn}>
                            <MessageSquare />
                            Send Quote
                          </Button>
                          <Button variant="outline" className={`${styles.jobSaveBtn} bg-transparent`}>
                            <Heart />
                          </Button>
                        </div>
                      </Card>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <button onClick={nextJobSlide} className={`${styles.carouselNavBtn} ${styles.carouselNext}`}>
              <ChevronRight />
            </button>
          </div>

          <div className={styles.carouselDots}>
            {Array.from({ length: Math.ceil(liveJobs.length / 3) }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentJobSlide(index)}
                className={`${styles.carouselDot} ${index === currentJobSlide ? styles.carouselDotActive : ""}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className={styles.successStoriesSection} id="success-stories" data-animate>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Real Success Stories</h2>
            <p className={styles.sectionSubtitle}>See how BuildStart has transformed businesses like yours</p>
          </div>

          <div className={styles.successStoriesGrid}>
            {successStories.map((story, index) => (
              <Card key={index} className={styles.successStoryCard}>
                <div className={styles.storyMetrics}>
                  <div className={styles.storyMetric}>
                    <div className={styles.metricValue}>{story.monthlyJobs}</div>
                    <div className={styles.metricLabel}>Jobs/Month</div>
                  </div>
                  <div className={styles.storyMetric}>
                    <div className={styles.metricValue}>{story.monthlyRevenue}</div>
                    <div className={styles.metricLabel}>Monthly Revenue</div>
                  </div>
                  <div className={`${styles.storyMetric} ${styles.growthMetric}`}>
                    <div className={`${styles.metricValue} ${styles.growthValue}`}>
                      <TrendingUp />
                      {story.growth}
                    </div>
                    <div className={styles.metricLabel}>Growth</div>
                  </div>
                </div>

                <p className={styles.storyTestimonial}>"{story.testimonial}"</p>

                <div className={styles.storyAuthor}>
                  <Avatar className={styles.storyAvatar}>
                    <AvatarImage src={story.image || "/placeholder.svg"} />
                    <AvatarFallback>{story.name.charAt(0)}</AvatarFallback>
                  </Avatar>
                  <div className={styles.storyInfo}>
                    <div className={styles.storyName}>{story.name}</div>
                    <div className={styles.storyJoined}>Joined {story.joinedDate}</div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className={styles.featuresSection} id="features" data-animate>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Everything You Need to Succeed</h2>
            <p className={styles.sectionSubtitle}>Powerful tools and features designed to grow your business</p>
          </div>

          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Target />
              </div>
              <h3 className={styles.featureTitle}>Qualified Leads Only</h3>
              <p className={styles.featureDescription}>
                Every lead is verified and pre-qualified. No time wasters, just serious customers ready to hire.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Zap />
              </div>
              <h3 className={styles.featureTitle}>Instant Notifications</h3>
              <p className={styles.featureDescription}>
                Get notified immediately when new jobs match your services. Be first to respond and win more work.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <BarChart3 />
              </div>
              <h3 className={styles.featureTitle}>Business Analytics</h3>
              <p className={styles.featureDescription}>
                Track your performance, conversion rates, and revenue growth with detailed analytics and insights.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <MessageSquare />
              </div>
              <h3 className={styles.featureTitle}>Direct Communication</h3>
              <p className={styles.featureDescription}>
                Chat directly with customers through our secure messaging system. Build relationships and close deals
                faster.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Calendar />
              </div>
              <h3 className={styles.featureTitle}>Job Management</h3>
              <p className={styles.featureDescription}>
                Organize your projects, track progress, and manage schedules all in one place. Stay on top of every job.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <Award />
              </div>
              <h3 className={styles.featureTitle}>Build Your Reputation</h3>
              <p className={styles.featureDescription}>
                Collect reviews and showcase your best work. A strong profile leads to more high-value opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className={styles.pricingSection} id="pricing" data-animate>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Choose Your Growth Plan</h2>
            <p className={styles.sectionSubtitle}>
              Start free, upgrade when you're ready. All plans include our success guarantee.
            </p>
          </div>

          <div className={styles.pricingGrid}>
            {pricingPlans.map((plan, index) => (
              <Card key={index} className={`${styles.pricingCard} ${plan.popular ? styles.pricingCardPopular : ""}`}>
                {plan.popular && (
                  <div className={styles.popularBadge}>
                    <Star />
                    Most Popular
                  </div>
                )}

                <div className={styles.pricingHeader}>
                  <h3 className={styles.pricingName}>{plan.name}</h3>
                  <p className={styles.pricingDescription}>{plan.description}</p>
                  <div className={styles.pricingPrice}>
                    <span className={styles.priceAmount}>{plan.price}</span>
                    <span className={styles.pricePeriod}>{plan.period}</span>
                  </div>
                </div>

                <ul className={styles.pricingFeatures}>
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className={styles.pricingFeature}>
                      <CheckCircle />
                      {feature}
                    </li>
                  ))}
                </ul>

                <Button className={`${styles.pricingButton} ${plan.popular ? styles.pricingButtonPopular : ""}`} size="lg">
                  {plan.popular ? "Start Free Trial" : "Get Started"}
                  <ArrowRight />
                </Button>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={styles.businessCtaSection}>
        <div className={styles.container}>
          <div className={styles.businessCtaContent}>
            <h2 className={styles.businessCtaTitle}>Ready to Transform Your Business?</h2>
            <p className={styles.businessCtaSubtitle}>
              Join thousands of professionals who have grown their revenue with BuildStart. Start your free trial today
              - no credit card required.
            </p>
            <div className={styles.businessCtaButtons}>
              <Button size="lg" className={styles.businessCtaPrimary}>
                <Zap />
                Start Free 14-Day Trial
              </Button>
              <Button size="lg" variant="outline" className={`${styles.businessCtaSecondary} bg-transparent`}>
                <Phone />
                Schedule Demo Call
              </Button>
            </div>
            <p className={styles.businessCtaGuarantee}>
              <CheckCircle />
              30-day money-back guarantee • Cancel anytime • No setup fees
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.businessFooter}>
        <div className={styles.container}>
          <div className={styles.footerContent}>
            <div className={styles.footerSection}>
              <div className={styles.footerLogo}>
                <HardHat className={styles.footerLogoIcon} />
                <span className={styles.footerLogoText}>BuildStart</span>
              </div>
              <p className={styles.footerDescription}>Empowering professionals to grow their business since 2020.</p>
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>For Professionals</h4>
              <ul className={styles.footerLinks}>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Join BuildStart
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Success Stories
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Help Center
                  </a>
                </li>
              </ul>
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>Resources</h4>
              <ul className={styles.footerLinks}>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Business Tips
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    Industry Reports
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Webinars
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    API Documentation
                  </a>
                </li>
              </ul>
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>Support</h4>
              <ul className={styles.footerLinks}>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Live Chat
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Phone Support
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Training
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.footerBottom}>
            <p className={styles.footerCopyright}>© 2024 BuildStart. All rights reserved.</p>
            <div className={styles.footerLegal}>
              <a href="#" className={styles.footerLegalLink}>
                Privacy Policy
              </a>
              <a href="#" className={styles.footerLegalLink}>
                Terms of Service
              </a>
              <a href="#" className={styles.footerLegalLink}>
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default BusinessLandingPagePureCSS
